import { compose, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import { showPromotionsDetailModalPage } from 'components/PromotionsDetailModalPage/actions'

export default compose(
  connect(null, { showPromotionsDetailModalPage }),
  withHandlers({
    showPromotionModal: ({ showPromotionsDetailModalPage }) => promoId => () => showPromotionsDetailModalPage(promoId)
  })
)
